import React from 'react';
import { Button, LinkBase } from '@miro-site/ui-foundation';
import { UserStatus } from '@miro-site/utils-helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var MetaMenu = function MetaMenu(_ref) {
  var contactSalesLink = _ref.contactSalesLink,
      dashboardLink = _ref.dashboardLink,
      loginLink = _ref.loginLink,
      signupLink = _ref.signupLink,
      userStatus = _ref.userStatus;

  if (userStatus === UserStatus.loading) {
    return null;
  }

  var isLoggedIn = userStatus === UserStatus.loggedIn;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [contactSalesLink && /*#__PURE__*/_jsx(LinkBase, {
      variant: "anchor",
      withHoverBg: true,
      className: "d-none d-md-flex align-self-center text-decoration-none",
      size: "sm",
      href: contactSalesLink === null || contactSalesLink === void 0 ? void 0 : contactSalesLink.href,
      children: contactSalesLink === null || contactSalesLink === void 0 ? void 0 : contactSalesLink.label
    }), /*#__PURE__*/_jsxs("div", {
      className: "d-flex gap-100",
      children: [!isLoggedIn && loginLink && /*#__PURE__*/_jsx(Button, {
        variant: "outline",
        href: loginLink === null || loginLink === void 0 ? void 0 : loginLink.href,
        size: "md",
        withStroke: true,
        children: loginLink === null || loginLink === void 0 ? void 0 : loginLink.label
      }), !isLoggedIn && signupLink && /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        href: signupLink === null || signupLink === void 0 ? void 0 : signupLink.href,
        size: "md",
        withStroke: true,
        children: signupLink === null || signupLink === void 0 ? void 0 : signupLink.label
      }), isLoggedIn && dashboardLink && /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        href: dashboardLink === null || dashboardLink === void 0 ? void 0 : dashboardLink.href,
        size: "md",
        withStroke: true,
        children: dashboardLink === null || dashboardLink === void 0 ? void 0 : dashboardLink.label
      })]
    })]
  });
};